import React, {useEffect, useState} from 'react'
import _ from "lodash";
import {
    DEFAULT_POD_TAB,
    PARENT_PRODUCT_DETAIL_TABS_LIST,
    PARENT_PRODUCT_FIELD_LIST,
    PRODUCT_DETAIL_KEY, PRODUCT_UPLOAD_TABS_LIST,
    SAVE_PARENT_PRODUCT_TIME_DELAY,
    SAVE_POD_TIME_DELAY
} from "../../../constants/pod.constant";
import RenderFields from "../../../../common/ui/render-fields";
import ParentProductColorList from "./parent-product-color-list";
import ParentProductSizeList from "./parent-product-size-list";
import {updateSingleParentProduct} from "../../../services/parent-product-data-service";
import {convertInchToPixel} from "../../../utils/dimension-util";
import ShowTabsList from "../../../../common/ui/show-tabs-list";
import SelectTags from "../../../../tag/select-tags";
import SearchTargetingInterest from "../../../../facebook/components/targeting/search-targeting-interest";
import TargetingInterestsList from "../../../../facebook/components/targeting-interest/targeting-interest-list";
import {
    addSingleTargetingInterest,
    searchTargetingInterestsWithSearchCriteria, updateSingleTargetingInterest
} from "../../../../facebook/services/facebook-targeting-interest-data.service";
import AddEditCampaign from "../../../../facebook/components/campaign/add-edit-campaign";
import {searchCampaignsWithSearchCriteria} from "../../../../facebook/services/facebook-campaign-data.service";

const fieldsByGroup = _.groupBy(PARENT_PRODUCT_FIELD_LIST, 'group');
const tabsList = PARENT_PRODUCT_DETAIL_TABS_LIST;

const ParentProductDetail = ({parentProduct, setParentProduct, allTags}) => {
    let [changesCount, setChangesCount] = useState(0);
    const [enableEdit, setEnableEdit] = useState(false);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_POD_TAB);
    const [interestsList, setInterestsList] = useState([]);
    const [facebookTargetingInterest, setFacebookTargetingInterest] = useState({} as any);
    const [facebookCampaign, setFacebookCampaign] = useState(null);

    useEffect(() => {
        if (parentProduct) {
            prepareFacebookSearchInterests(parentProduct);
            getFacebookTargetingInterest();
            getFacebookCampaign();
        }
    }, [parentProduct?.id]);

    const prepareFacebookSearchInterests = (parentProduct) => {
        let searchInterestTextList = [];
        searchInterestTextList.push(parentProduct?.productType);
        searchInterestTextList.push(parentProduct?.title);
        searchInterestTextList.push(parentProduct?.name);
        searchInterestTextList.push(parentProduct?.model);
        searchInterestTextList.push(parentProduct?.category);

        let parentCategories = _.split(parentProduct?.parentCategory, '|');
        parentCategories = _.map(parentCategories, (category) => {
            return _.trim(category);
        });
        searchInterestTextList = _.concat(searchInterestTextList, parentCategories);

        const tagsMap = _.keyBy(allTags, 'id');
        _.forEach(parentProduct?.tagList, (tagId) => {
            searchInterestTextList.push(tagsMap[tagId]?.startText);
        });
        searchInterestTextList = _.uniq(_.compact(searchInterestTextList))
        setInterestsList(searchInterestTextList);
    }

    const getFacebookTargetingInterest = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'parentProductId', condition: '==', value: parentProduct?.id});
        const facebookTargetingInterestsResult = await searchTargetingInterestsWithSearchCriteria(searchCriteriaList);

        if (facebookTargetingInterestsResult?.length > 0) {
            setFacebookTargetingInterest(facebookTargetingInterestsResult[0]);
        } else {
            setFacebookTargetingInterest(null);
        }
    }

    const getFacebookCampaign = async () => {
        const searchCriteriaList = [];
        searchCriteriaList.push({field: 'parentProductId', condition: '==', value: parentProduct?.id});
        const facebookCampaignsResult = await searchCampaignsWithSearchCriteria(searchCriteriaList);

        if (facebookCampaignsResult?.length > 0) {
            setFacebookCampaign(facebookCampaignsResult[0]);
        } else {
            setFacebookCampaign(null);
        }
    }


    const handleDetailChanges = async (event) => {
        const {name, value, type} = event.target;
        const existingParentProduct = {...parentProduct};

        if (type === 'checkbox') {
            existingParentProduct[name] = !existingParentProduct[name];
        } else {
            existingParentProduct[name] = value;
            if (name === PRODUCT_DETAIL_KEY.HEIGHT_INCH) {
                existingParentProduct[PRODUCT_DETAIL_KEY.HEIGHT_PIXEL] = convertInchToPixel(value);
            } else if (name === PRODUCT_DETAIL_KEY.WIDTH_INCH) {
                existingParentProduct[PRODUCT_DETAIL_KEY.WIDTH_PIXEL] = convertInchToPixel(value);
            }
        }

        if (name === 'tagList') {
            const tempTags = {};
            _.forEach(value, tagId => {
                tempTags[tagId] = true;
            });

            existingParentProduct['tags'] = tempTags;
            existingParentProduct['tagList'] = value;
        }

        setParentProduct(existingParentProduct);
        await updateSingleParentProduct(existingParentProduct);
    }

    useEffect(() => {
        incrementChangesCount();
    }, [parentProduct]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    saveParentProductChanges();
                }

            }, SAVE_PARENT_PRODUCT_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const saveParentProductChanges = async () => {
        const existingParentProduct = {...parentProduct};

        if (!_.isEmpty(existingParentProduct)) {
            // console.log('SaveParentProductChanges...', existingParentProduct);
            await updateSingleParentProduct(existingParentProduct);
        }
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    const afterSearchInterestsResult = async (interestsMap) => {
        let existingFacebookTargetingInterest: any = {...facebookTargetingInterest};

        if (!_.isEmpty(existingFacebookTargetingInterest)) {
            existingFacebookTargetingInterest['interests'] = interestsMap;
            await updateSingleTargetingInterest(existingFacebookTargetingInterest);
            setFacebookTargetingInterest(existingFacebookTargetingInterest);
        } else {
            const newFacebookTargetingInterest = {
                parentProductId: parentProduct?.id,
                interests: interestsMap
            }

            const addedDoc = await addSingleTargetingInterest(newFacebookTargetingInterest);
            newFacebookTargetingInterest['id'] = addedDoc.id;
            setFacebookTargetingInterest(newFacebookTargetingInterest);
        }
    }

    return (
        <>

            <div className="flex justify-between">
                <div className="text-lg mt-1 flex justify-start">
                    <div className="mr-1 text-purple-700 font-semibold">{parentProduct?.name}</div>
                    |
                    <div className="mx-1 font-semibold">{parentProduct?.productType}</div>
                    |
                    <div className="mx-1 font-semibold">{parentProduct?.category}</div>
                    {facebookTargetingInterest?.relevantInterests?.length > 0 &&
                        <div
                            className={'ml-2 px-2 py-1 text-center self-center text-sm -mt-1 border border-blue-800 bg-blue-100 text-blue-800 rounded-xl'}>
                            {facebookTargetingInterest?.relevantInterests?.length} Interests
                        </div>
                    }
                </div>

                <div className={'flex justify-end items-center'}>
                    <SearchTargetingInterest
                        afterSearch={afterSearchInterestsResult}
                        searchTextList={interestsList}/>

                    <div className="ml-2">
                        {!facebookCampaign &&
                            <AddEditCampaign
                                refreshCampaignList={getFacebookCampaign}
                                isAddCampaign={true}
                                parentProduct={parentProduct}/>
                        }

                        {facebookCampaign &&
                            <AddEditCampaign
                                refreshCampaignList={getFacebookCampaign}
                                isEditCampaign={true}
                                selectedCampaign={facebookCampaign}
                                parentProduct={parentProduct}/>
                        }
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <ShowTabsList
                    setSelectedTab={setSelectedTab}
                    selectedTab={selectedTab}
                    tabsList={tabsList}/>
            </div>

            {selectedTab?.key === 'details' &&
                <>
                    <div className="bg-gray-100 rounded mt-4 p-4">
                        <div className="flex justify-end">
                            <div className="field-container w-full justify-start flex mt-2">
                                <input
                                    type="checkbox"
                                    className="h-6 w-6 mr-1"
                                    id="allowHalfWidthDesign"
                                    name="allowHalfWidthDesign"
                                    value={parentProduct?.allowHalfWidthDesign}
                                    checked={parentProduct?.allowHalfWidthDesign}
                                    onChange={handleDetailChanges}>
                                </input>
                                <div className='ml-1'>
                                    <label className='field-label self-center'
                                           htmlFor='allowHalfWidthDesign'>Allow Half Width Design</label>
                                </div>
                            </div>

                            <div className="float-right">
                                <button
                                    onClick={() => setEnableEdit(!enableEdit)}
                                    className="button-small ml-4 w-48">
                                    {!enableEdit && <span>Edit Fields</span>}
                                    {enableEdit && <span>Ready Only Fields</span>}
                                </button>
                            </div>
                        </div>

                        <div className="flex justify-start mt-2">

                            <div className="w-full">
                                <RenderFields
                                    parentForm={parentProduct}
                                    handleDetailChanges={handleDetailChanges}
                                    fieldList={fieldsByGroup['detail']}
                                    enableEdit={enableEdit}
                                    fieldClassName={undefined}/>
                            </div>

                            <div className="w-1/4">
                                <RenderFields
                                    parentForm={parentProduct}
                                    handleDetailChanges={handleDetailChanges}
                                    fieldList={fieldsByGroup['measurement']}
                                    enableEdit={enableEdit}
                                    fieldClassName={undefined}/>
                            </div>

                            <div className="w-1/4">
                                <RenderFields
                                    parentForm={parentProduct}
                                    handleDetailChanges={handleDetailChanges}
                                    fieldList={fieldsByGroup['info']}
                                    enableEdit={enableEdit}
                                    fieldClassName={undefined}/>
                            </div>

                            <div className="w-1/4">
                                <RenderFields
                                    parentForm={parentProduct}
                                    handleDetailChanges={handleDetailChanges}
                                    fieldList={fieldsByGroup['total']}
                                    enableEdit={enableEdit}
                                    fieldClassName={undefined}/>
                            </div>

                        </div>
                    </div>

                    <div>
                        {allTags &&
                            <div
                                className="h-80 overflow-y-scroll border-gray-400 border bg-blue-50 mb-4 rounded mt-4 shadow-xl">
                                <SelectTags
                                    existingTags={parentProduct?.tagList}
                                    allTags={allTags}
                                    handleSelectTagsChanges={handleDetailChanges}
                                    showAddTag={true}
                                    showClearSelectedTags={false}
                                    showClearSelectedTagsIcon={false}/>
                            </div>
                        }
                    </div>

                </>
            }

            {selectedTab?.key === 'colors-sizes' &&
                <div className="flex justify-start mt-4 w-full">

                    <div className="w-1/2 mr-2 p-4 bg-gray-100 rounded">
                        <ParentProductColorList
                            parentProduct={parentProduct}
                            setParentProduct={setParentProduct}/>
                    </div>

                    <div className="w-1/2 ml-2 p-4 bg-gray-100 rounded">
                        <ParentProductSizeList
                            parentProduct={parentProduct}
                            setParentProduct={setParentProduct}
                            fieldList={fieldsByGroup['measurement']}/>
                    </div>

                </div>
            }

            {selectedTab?.key === 'facebook-interests' &&
                <div className="mt-4 mb-10 w-full">

                    {facebookTargetingInterest &&
                        <TargetingInterestsList
                            facebookTargetingInterest={facebookTargetingInterest}
                            setFacebookTargetingInterest={setFacebookTargetingInterest}/>
                    }

                </div>
            }

        </>
    )
}

export default ParentProductDetail
